module.exports = new __parcel__URL__("../RobotoMono-Medium.5a7b3c17.ttf").toString();